import { useEffect } from 'react';
import { useSessionContext } from '@issuemanager/apps/client/contexts';

// pendo is a global variable that is injected by the Pendo script
declare const pendo: any;

export function Pendo() {
  const session = useSessionContext();

  useEffect(() => {
    if (session && typeof pendo !== 'undefined') {
      const { org_id: orgId, name, email, uid, subdomain } = session;
      const pendoOptions = {
        visitor: {
          id: uid,
          email,
          fullname: name,
        },
        account: {
          id: orgId,
          account_subdomain: subdomain,
        },
      };
      pendo.initialize(pendoOptions);
    }
  }, [session]);

  return null;
}
